import { render } from "./Header.vue?vue&type=template&id=a37987ae&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=a37987ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\99170\\Desktop\\whole-project\\iridea-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37987ae"]])

export default __exports__